import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_AUTH_FORM_MODE, type AuthFormMode } from './types';

const initialState: AuthFormMode = 'signup';

export function authFormModeReducer(state = initialState, action: PayloadAction<AuthFormMode>): AuthFormMode {
	switch (action.type) {
		case SET_AUTH_FORM_MODE:
			return action.payload;
		default:
			return state;
	}
}
